import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const TextUnderlineFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function TextUnderlineFilled({
  title = 'Text underline',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Text underline'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M21 19H3v3h18v-3ZM11.7 17h.6c1.4 0 2.6-.4 3.7-1.1V17h3V2h-3v8.3c0 2-1.7 3.7-3.7 3.7h-.6c-2 0-3.7-1.7-3.7-3.7V2H5v8.3C5 14 8 17 11.7 17Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default TextUnderlineFilled;